import State from './state';

const InterfaceFaqsResponse = {
  id: 0,
  question: '',
  answer: '',
  topic: '',
};

function translateFaqsPostAPItoFaqsStore(posts = [{ ...InterfaceFaqsResponse }]) {
  return posts.map((post) => ({
    title: post.question,
    topic: post.topic,
    content: post.answer,
  }));
}

export function cleanErrors(state) {
  state.error = false;
  state.errorMessage = '';
}

export function error(state, payload) {
  state.error = true;
  state.errorMessage = payload;
}

export function setIsCharging(state, value) {
  state.charging = value;
}

export function saveAboutUs(state, data) {
  state.about = data;
}

export function saveChildStars(state, data) {
  let aux = state.childStars;
  state.childStars = {};
  state.childStars = aux;
  state.childStars[data.id] = data.stars;
}

export function saveCriterionDescription(state, data) {
  state.CriterionDescription = data;
}

export function saveAvatarImages(state, data) {
  state.avatarImages = data;
}

export function setFaqsPost(state = State, posts = []) {
  const postsTranslate = translateFaqsPostAPItoFaqsStore(posts);
  state.faq.posts = postsTranslate;
}

export function setFaqsTopics(state = State, topics = []) {
  state.faq.topics = [...topics];
}
